import { api_instance } from ".";

export const loginAPI = async (body) => {
  const response = await api_instance.post("/auth/login", body);
  return response;
};
